import React, { createContext, useContext, useState, ReactNode } from 'react';

interface VideoContextType {
  videoEnded: boolean;
  logoAnimationComplete: boolean;
  hideAnimatedLogo: boolean;
  navbarLogoVisible: boolean;
  setVideoEnded: (ended: boolean) => void;
  setLogoAnimationComplete: (complete: boolean) => void;
  setHideAnimatedLogo: (hide: boolean) => void;
  setNavbarLogoVisible: (visible: boolean) => void;
}

const VideoContext = createContext<VideoContextType | undefined>(undefined);

export const useVideo = () => {
  const context = useContext(VideoContext);
  if (context === undefined) {
    throw new Error('useVideo must be used within a VideoProvider');
  }
  return context;
};

interface VideoProviderProps {
  children: ReactNode;
}

export const VideoProvider: React.FC<VideoProviderProps> = ({ children }) => {
  const [videoEnded, setVideoEnded] = useState(false);
  const [logoAnimationComplete, setLogoAnimationComplete] = useState(false);
  const [hideAnimatedLogo, setHideAnimatedLogo] = useState(false);
  const [navbarLogoVisible, setNavbarLogoVisible] = useState(false);

  return (
    <VideoContext.Provider value={{
      videoEnded,
      logoAnimationComplete,
      hideAnimatedLogo,
      navbarLogoVisible,
      setVideoEnded,
      setLogoAnimationComplete,
      setHideAnimatedLogo,
      setNavbarLogoVisible
    }}>
      {children}
    </VideoContext.Provider>
  );
};
